import { TranslateFunction } from "../../../../hooks/useTranslate";

export const CONTRACTOR_BUSINESS_TYPES = [
    { id: 1, value: 1, nombre: 'Contratista' },
    { id: 2, value: 2, nombre: 'Tercerizada' }
];

export const contractorsTableColumnTitles = (t: TranslateFunction): string[] => [
    t('table.contractors.columnsTitles.cuit'),
    t('table.contractors.columnsTitles.companyActivity'),
    t('table.contractors.columnsTitles.companyType'),
    t('table.contractors.columnsTitles.employeeQuantity'),
    t('table.contractors.columnsTitles.actions')
];

export const responsiblesTableColumnTitles = (t: TranslateFunction): string[] => [
    t('table.responsibles.columnsTitles.fullname'),
    t('table.responsibles.columnsTitles.charge'),
    t('table.responsibles.columnsTitles.cuit'),
    t('table.responsibles.columnsTitles.respresentation'),
    t('table.responsibles.columnsTitles.status'),
    t('table.responsibles.columnsTitles.habilitationTitle'),
    t('table.responsibles.columnsTitles.licenceNumber'),
    t('table.responsibles.columnsTitles.grantingEntity'),
    t('table.responsibles.columnsTitles.actions')
];